import { render, staticRenderFns } from "./AppointmentConfirm.vue?vue&type=template&id=593919aa&scoped=true"
import script from "./AppointmentConfirm.vue?vue&type=script&lang=js"
export * from "./AppointmentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593919aa",
  null
  
)

export default component.exports